import React from 'react'
import { Chip } from '@material-ui/core'
import { getStatusMetadata } from 'src/common/NACommon'
import moment from 'moment-timezone'
import A6aApiUrls from 'src/apiUrls/A6aApiUrls'
import { constants } from 'cng-web-lib'
import TemplateSelectDialog from 'src/components/aciacehighway/TemplateSelectDialog'
import { useHistory } from 'react-router-dom'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'

function TemplateSelectDialogWithOptionA6A(props) {
  const {
    a6aTemplateDialog,
    setA6aTemplateDialog,
    showNotification,
    setValue,
    reset,
    trigger,
    isTable,
    location,
    rowActions
  } = props

  const {
    filter: { LIKE, EQUAL }
  } = constants

  const history = useHistory()

  function handleApplyA6ATemplate(template) {
    if (!template) {
      reset()
      return
    }

    const {
      carrierCode,
      uniqueConsignmentRefNo,
      ccn,
      originalCcn,
      mot,
      customsProcedure,
      bolNo,
      specialIns,
      supplementaryReqInd,
      bulkShipment,
      a6ConvRefNo,
      vesselName,
      voyageNo,
      portOfLoading,
      terminalOfLoading,
      pierOfLoading,
      estimatedLoadingDate,
      vesselDepartureDate,
      customsOfficeOfExit,
      portOfArrival,
      pierOfArrival,
      foreignPortOfLading,
      cargoLoadingCity,
      cargoLoadingPort,
      customsOffOfPortArrival,
      customsOffOfPortArrivalSubLocCode,
      customsOffOfManifestDestination,
      customsOffOfManifestDestinationSubLocCode,
      cargoDestinationCountry,
      cargoDestinationCity,
      cargoDestinationPort,
      customsOffOfDischarge,
      arrivalTerminal,
      carrierName,
      terminalName,
      portOfDischarge,
      docFormat,
      messageFunction,
      taciOcnA6aParties,
      taciOcnA6aShipments,
      taciOcnA6aContainers,
      taciOcnA6aSN,
      a6aExports,
      a6aPrevious
    } = template

    // Clear IDs from child records before applying
    function clearIds(arr) {
      if (!arr) return []
      return arr.map((item) => ({
        ...item,
        id: null,
        createdBy: null,
        createdDate: null,
        updatedBy: null,
        updatedDate: null
      }))
    }

    if (isTable) {
      const templateJson = {
        id: null,
        version: 0,
        createdBy: null,
        createdDate: null,
        updatedBy: null,
        updatedDate: null,
        partyId: null,
        templateFlag: false,
        templateName: '',
        a6aStatus: '',
        docFormat: docFormat || '',
        carrierCode: carrierCode || '',
        uniqueConsignmentRefNo: uniqueConsignmentRefNo || '',
        ccn: ccn || '',
        originalCcn: originalCcn || '',
        mot: mot || '',
        customsProcedure: customsProcedure || '',
        bolNo: bolNo || '',
        specialIns: specialIns || '',
        supplementaryReqInd: supplementaryReqInd || '',
        bulkShipment: bulkShipment || '',
        a6ConvRefNo: a6ConvRefNo || '',
        vesselName: vesselName || '',
        voyageNo: voyageNo || '',
        portOfLoading: portOfLoading || '',
        terminalOfLoading: terminalOfLoading || '',
        pierOfLoading: pierOfLoading || '',
        estimatedLoadingDate: estimatedLoadingDate || '',
        vesselDepartureDate: vesselDepartureDate || '',
        customsOfficeOfExit: customsOfficeOfExit || '',
        portOfArrival: portOfArrival || '',
        pierOfArrival: pierOfArrival || '',
        foreignPortOfLading: foreignPortOfLading || '',
        cargoLoadingCity: cargoLoadingCity || '',
        cargoLoadingPort: cargoLoadingPort || '',
        customsOffOfPortArrival: customsOffOfPortArrival || '',
        customsOffOfPortArrivalSubLocCode: customsOffOfPortArrivalSubLocCode || '',
        customsOffOfManifestDestination: customsOffOfManifestDestination || '',
        customsOffOfManifestDestinationSubLocCode: customsOffOfManifestDestinationSubLocCode || '',
        cargoDestinationCountry: cargoDestinationCountry || '',
        cargoDestinationCity: cargoDestinationCity || '',
        cargoDestinationPort: cargoDestinationPort || '',
        customsOffOfDischarge: customsOffOfDischarge || '',
        arrivalTerminal: arrivalTerminal || '',
        carrierName: carrierName || '',
        terminalName: terminalName || '',
        portOfDischarge: portOfDischarge || '',
        messageFunction: messageFunction || '9',
        taciOcnA6aParties: clearIds(taciOcnA6aParties),
        taciOcnA6aShipments: clearIds(taciOcnA6aShipments),
        taciOcnA6aContainers: clearIds(taciOcnA6aContainers),
        taciOcnA6aSN: clearIds(taciOcnA6aSN),
        a6aExports: clearIds(a6aExports),
        a6aPrevious: clearIds(a6aPrevious)
      }

      history.push(`${location.pathname}/add`, templateJson)
    } else {
      setValue('docFormat', docFormat || '', { shouldDirty: true })
      setValue('carrierCode', carrierCode || '', { shouldDirty: true })
      setValue('uniqueConsignmentRefNo', uniqueConsignmentRefNo || '', { shouldDirty: true })
      setValue('ccn', ccn || '', { shouldDirty: true })
      setValue('originalCcn', originalCcn || '', { shouldDirty: true })
      setValue('mot', mot || '', { shouldDirty: true })
      setValue('customsProcedure', customsProcedure || '', { shouldDirty: true })
      setValue('bolNo', bolNo || '', { shouldDirty: true })
      setValue('specialIns', specialIns || '', { shouldDirty: true })
      setValue('supplementaryReqInd', supplementaryReqInd || '', { shouldDirty: true })
      setValue('bulkShipment', bulkShipment || '', { shouldDirty: true })
      setValue('a6ConvRefNo', a6ConvRefNo || '', { shouldDirty: true })
      setValue('vesselName', vesselName || '', { shouldDirty: true })
      setValue('voyageNo', voyageNo || '', { shouldDirty: true })
      setValue('portOfLoading', portOfLoading || '', { shouldDirty: true })
      setValue('terminalOfLoading', terminalOfLoading || '', { shouldDirty: true })
      setValue('pierOfLoading', pierOfLoading || '', { shouldDirty: true })
      setValue('estimatedLoadingDate', estimatedLoadingDate || '', { shouldDirty: true })
      setValue('vesselDepartureDate', vesselDepartureDate || '', { shouldDirty: true })
      setValue('customsOfficeOfExit', customsOfficeOfExit || '', { shouldDirty: true })
      setValue('portOfArrival', portOfArrival || '', { shouldDirty: true })
      setValue('pierOfArrival', pierOfArrival || '', { shouldDirty: true })
      setValue('foreignPortOfLading', foreignPortOfLading || '', { shouldDirty: true })
      setValue('cargoLoadingCity', cargoLoadingCity || '', { shouldDirty: true })
      setValue('cargoLoadingPort', cargoLoadingPort || '', { shouldDirty: true })
      setValue('customsOffOfPortArrival', customsOffOfPortArrival || '', { shouldDirty: true })
      setValue('customsOffOfPortArrivalSubLocCode', customsOffOfPortArrivalSubLocCode || '', { shouldDirty: true })
      setValue('customsOffOfManifestDestination', customsOffOfManifestDestination || '', { shouldDirty: true })
      setValue('customsOffOfManifestDestinationSubLocCode', customsOffOfManifestDestinationSubLocCode || '', { shouldDirty: true })
      setValue('cargoDestinationCountry', cargoDestinationCountry || '', { shouldDirty: true })
      setValue('cargoDestinationCity', cargoDestinationCity || '', { shouldDirty: true })
      setValue('cargoDestinationPort', cargoDestinationPort || '', { shouldDirty: true })
      setValue('customsOffOfDischarge', customsOffOfDischarge || '', { shouldDirty: true })
      setValue('arrivalTerminal', arrivalTerminal || '', { shouldDirty: true })
      setValue('carrierName', carrierName || '', { shouldDirty: true })
      setValue('terminalName', terminalName || '', { shouldDirty: true })
      setValue('portOfDischarge', portOfDischarge || '', { shouldDirty: true })
      setValue('messageFunction', messageFunction || '9', { shouldDirty: true })
      setValue('taciOcnA6aParties', clearIds(taciOcnA6aParties), { shouldDirty: true })
      setValue('taciOcnA6aShipments', clearIds(taciOcnA6aShipments), { shouldDirty: true })
      setValue('taciOcnA6aContainers', clearIds(taciOcnA6aContainers), { shouldDirty: true })
      setValue('taciOcnA6aSN', clearIds(taciOcnA6aSN), { shouldDirty: true })
      setValue('a6aExports', clearIds(a6aExports), { shouldDirty: true })
      setValue('a6aPrevious', clearIds(a6aPrevious), { shouldDirty: true })

      showNotification('success', 'Template applied successfully.')
      trigger()
    }
  }

  const columns = [
    {
      field: 'id',
      title: 'ID'
    },
    {
      field: 'templateName',
      title: 'Template Name'
    },
    {
      field: 'carrierCode',
      title: 'Carrier Code'
    },
    {
      field: 'vesselName',
      title: 'Vessel Name'
    },
    {
      field: 'a6aStatus',
      title: 'Status',
      render: (data) => {
        const status = getStatusMetadata(data.a6aStatus)
        return (
          <Chip
            label={status.label}
            size='small'
            style={{
              backgroundColor: status.color,
              color: status.contrastColor,
              fontSize: 12
            }}
          />
        )
      }
    },
    {
      field: 'createdDate',
      title: 'Created Date',
      render: (data) =>
        data.createdDate &&
        moment(data.createdDate).tz('Canada/Eastern').format('D MMM YYYY, HH:mm')
    },
    {
      field: 'updatedDate',
      title: 'Updated Date',
      render: (data) =>
        data.updatedDate &&
        moment(data.updatedDate).tz('Canada/Eastern').format('D MMM YYYY, HH:mm')
    },
    isTable ? {
      title: 'Action'
    } : {}
  ]

  return (
    <TemplateSelectDialog
      columns={columns}
      defaultSorts={[{ field: 'createdDate', direction: 'ASC' }]}
      fetch={{ url: A6aApiUrls.GET }}
      fetchFilters={[
        { field: 'templateFlag', operator: 'equal', value: true },
        { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
      ]}
      onApplyTemplate={handleApplyA6ATemplate}
      onClose={() => setA6aTemplateDialog(false)}
      open={a6aTemplateDialog}
      search={{ field: 'templateName', operator: LIKE }}
      title='A6A Template'
      rowActions={rowActions}
      isTable={isTable}
    />
  )
}

export default TemplateSelectDialogWithOptionA6A
